import apiClient from 'api/apiClient';

const BASE = process.env.REACT_APP_USER_REST_API_BASE_URL
  ? `${process.env.REACT_APP_USER_REST_API_BASE_URL}/api/v4/admin/plans`
  : 'http://localhost:8080/api/v4/admin/plans';

export interface FeatureConfig {
  featureKey: string;
  enabled: boolean;
  usageLimit: number | null;
}

export interface PlanRecord {
  id: number;
  tier: string;
  displayName: string;
  description: string | null;
  priceMonthly: number | null;
  priceAnnual: number | null;
  currency: string;
  status: 'DRAFT' | 'PUBLISHED' | 'RETIRED';
  version: number;
  publishedAt: string | null;
  createdAt: string | null;
  updatedAt: string | null;
  features: FeatureConfig[];
}

export interface FeatureConfigRequest {
  featureKey: string;
  enabled: boolean;
  usageLimit: number | null;
}

export interface PlanRequest {
  tier?: string;
  displayName?: string;
  description?: string;
  priceMonthly?: number | null;
  priceAnnual?: number | null;
  currency?: string;
  features?: FeatureConfigRequest[];
}

export const listPlans = () =>
  apiClient.get<PlanRecord[]>(BASE);

export const createPlan = (req: PlanRequest) =>
  apiClient.post<PlanRecord>(BASE, req);

export const updatePlan = (id: number, req: PlanRequest) =>
  apiClient.put<PlanRecord>(`${BASE}/${id}`, req);

export const publishPlan = (id: number) =>
  apiClient.post<PlanRecord>(`${BASE}/${id}/publish`);

export const clonePlan = (id: number) =>
  apiClient.post<PlanRecord>(`${BASE}/${id}/clone`);

export const retirePlan = (id: number) =>
  apiClient.put<PlanRecord>(`${BASE}/${id}/retire`);
